<script setup lang="ts">
useHead({
    meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { key: 'theme-color', name: 'theme-color', content: '#ffffff' },
    ],
    link: [{ rel: 'icon', href: '/favicon.ico' }],
    htmlAttrs: {
        lang: 'en',
        class: 'light', // force light mode; no dark mode
    },
})
useSeoMeta({
    ogImage: 'https://landing-template.nuxt.dev/social-card.png',
    twitterImage: 'https://landing-template.nuxt.dev/social-card.png',
    twitterCard: 'summary_large_image',
})
</script>

<template>
    <!-- `progress: false` drops Nuxt UI's countdown bar on every toast; `duration` still auto-closes them. -->
    <UApp :toaster="{ expand: false, progress: false }">
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>
